import React from 'react';
import { TrendingDown, Minus, TrendingUp } from 'lucide-react';

const ComparisonPill = ({ status, text, size = "md" }) => {
  const getStyles = () => {
    const baseStyles = {
      green: 'bg-green-100 text-green-800 border-green-300',
      yellow: 'bg-yellow-100 text-yellow-800 border-yellow-300',
      red: 'bg-red-100 text-red-800 border-red-300'
    };
    
    const sizeStyles = {
      sm: 'px-2 py-1 text-xs',
      md: 'px-3 py-1.5 text-sm',
      lg: 'px-4 py-2 text-base'
    };
    
    return `${baseStyles[status]} ${sizeStyles[size]} inline-flex items-center gap-2 rounded-full border font-medium`;
  };

  const getIcon = () => {
    const iconSize = size === 'sm' ? 14 : size === 'lg' ? 20 : 16;
    
    switch(status) {
      case 'green':
        return <TrendingDown size={iconSize} />;
      case 'yellow':
        return <Minus size={iconSize} />;
      case 'red':
        return <TrendingUp size={iconSize} />;
      default:
        return null;
    }
  };

  const getLabel = () => {
    switch(status) {
      case 'green':
        return 'Below Market';
      case 'yellow':
        return 'At Market';
      case 'red':
        return 'Above Market';
      default:
        return 'Unknown';
    }
  };

  return (
    <div 
      className={getStyles()}
      title={text}
    >
      {getIcon()}
      <span>{getLabel()}</span>
    </div>
  );
};

export default ComparisonPill;
